<template>
  <section class="info-section">
    <div class="section-header">
      <h3 class="section-title mb-0">
        {{ title }}
      </h3>
      <div class="button-group">
        <v-btn
          v-if="!isEditing && editable && canEdit"
          size="small"
          variant="outlined"
          color="#33B5B4"
          @click="$emit('toggle-edit')"
        >
          編集する
        </v-btn>
        <template v-if="isEditing">
          <v-btn
            size="small"
            variant="outlined"
            color="grey"
            :disabled="isSaving"
            @click="$emit('cancel-edit')"
          >
            キャンセル
          </v-btn>
          <v-btn
            size="small"
            variant="outlined"
            color="#33B5B4"
            :loading="isSaving"
            :disabled="isSaving"
            @click="$emit('toggle-edit')"
          >
            保存する
          </v-btn>
        </template>
      </div>
    </div>

    <div
      v-if="!editable || !isEditing"
      :class="{ 'note-box': true, readonly: readonly }"
    >
      {{ displayValue(content) }}
    </div>

    <template v-else>
      <p
        :id="`${title}-input-hint`"
        class="note-input-hint"
      >
        ※入力時は年月日を記載
      </p>
      <v-textarea
        :aria-describedby="`${title}-input-hint`"
        :model-value="draft"
        class="note-textarea"
        density="comfortable"
        variant="outlined"
        rows="3"
        hide-details
        @update:model-value="$emit('update:draft', $event)"
      />
    </template>
  </section>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  content: {
    type: String,
    default: "",
  },
  editable: {
    type: Boolean,
    default: false,
  },
  canEdit: {
    type: Boolean,
    default: true,
  },
  isEditing: {
    type: Boolean,
    default: false,
  },
  draft: {
    type: String,
    default: "",
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  isSaving: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["toggle-edit", "update:draft", "cancel-edit"]);

const displayValue = (value) => value ?? "";
</script>

<style lang="scss" scoped>
.info-section {
  background-color: #fff;
  border: 1px solid #e8e8e8;
  padding: 10px;
  margin-bottom: 10px;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.section-title {
  color: #33B5B4;
  font-size: clamp(16px, 1vw, 20px);
  line-height: 1.25;
  font-weight: 700;
  margin-bottom: 6px;
}

.button-group {
  display: flex;
  gap: 6px;
  align-items: center;
  margin-bottom: 4px;
}

.note-box {
  border: 1px solid #d4d8de;
  border-radius: 6px;
  background: #fff;
  min-height: 48px;
  padding: 10px;
  font-size: 13px;
  line-height: 1.5;
  color: #666;
  white-space: pre-wrap;
}

.note-box.readonly {
  background: #fafafa;
}

.note-textarea :deep(textarea) {
  font-size: 13px;
  line-height: 1.5;
}

.note-input-hint {
  color: #d32f2f;
  margin: 0 0 4px;
  font-size: 12px;
  text-align: left;
}

@media (max-width: 1280px) {
  .section-title {
    font-size: 15px;
  }

  .note-box,
  .note-textarea :deep(textarea) {
    font-size: 12px;
  }
}
</style>
